export default __webpack_public_path__ + "dfed6e0e9e164115d3be7f2921ecaf97.png";